import { render } from "./Retributions.vue?vue&type=template&id=726dc5f4&scoped=true"
import script from "./Retributions.vue?vue&type=script&lang=js"
export * from "./Retributions.vue?vue&type=script&lang=js"

import "./Retributions.vue?vue&type=style&index=0&id=726dc5f4&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-726dc5f4"]])

export default __exports__